// removed by extract-text-webpack-plugin
module.exports = {"img":"_1WtvBrpNMapkQNM7mTmfyR","myExperienceShop":"_1Yobo5r415I_hfQEMMuAnH","experienceShopNearby":"_1yJWkzk2pt_0cVwNra7KLR","backToHome":"_2Zyq0-OEScviIKl6xFnB_E"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ExperienceShopFirstPage/ExperienceShopFirstPage.scss
 ** module id = 1060
 ** module chunks = 0
 **/